import axios from 'axios';

const getIndicadores = () => axios.get('/indicadores/embarcador/indicadores', {});
const getIndicadoresContratos = () => axios.get('/indicadores/embarcador/indicadores/contratos ', {});
const getSavings = params => axios.get('/indicadores/embarcador/savings', { params });
const getContratos = params => axios.get('/indicadores/embarcador/contratos', { params });

export default {
  getIndicadores,
  getSavings,
  getContratos,
  getIndicadoresContratos,
};
